import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  Divider,
} from "@mui/material";
import { StyledCard } from "../common/StyledCard";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import CodeIcon from "@mui/icons-material/Code";
import { SmsTemplateResponseDto } from "../../shared/dtos/sms/SmsTemplateResponseDto";

interface SmsTemplateCardProps {
  template: SmsTemplateResponseDto;
  onEdit?: () => void;
  onDelete?: () => void;
}

const SmsTemplateCard: React.FC<SmsTemplateCardProps> = ({
  template,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledCard>
      <Box
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        <Stack
          sx={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <SmsOutlinedIcon />
            <Typography variant="h6" sx={{ fontWeight: "bold" }} noWrap>
              SMS Template
            </Typography>
          </Box>
          <Stack sx={{ flexDirection: "row" }}>
            {onEdit && (
              <Tooltip title="Edit">
                <IconButton size="small" color="secondary" onClick={onEdit}>
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            {onDelete && (
              <Tooltip title="Delete">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>
        <Chip
          label={template.templateCode}
          size="small"
          color="info"
          icon={<CodeIcon />}
          sx={{ alignSelf: "flex-start" }}
        />
        <Divider sx={{ my: 1.5 }} />
        <Box sx={{ flexGrow: 1, mb: 2 }}>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontStyle: "italic",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            &quot;{template.messageBody}&quot;
          </Typography>
        </Box>
      </Box>
    </StyledCard>
  );
};

export default SmsTemplateCard;
